<template>
  <div class="list">
    <ul>
      <li
        v-for="(item, idx) in items"
        :key="idx"
      >

        <slot name="content" :data="item"/>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'VList',
  props: {
    items: [Array, Object],
  },
};
</script>

<style lang='scss'>
.list {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  height: inherit;

  ul {
    overflow-y: scroll;
    height: inherit;

    li {
      position: relative;
      &::after {
        content: "\e90c";
        font-family: "ju-icon", sans-serif;
        font-size: 18px;
        color: var(--color-grey-6);
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -9px;
      }
      & > * {
        height: 56px;
        padding: 0 24px;
        font-size: var(--font-size-2);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border-bottom: 1px solid var(--color-grey-3);
        text-align: left;
      }
      &:first-child {
        & > * {
          border-color: var(--color-grey-3);
          border-style: solid;
          border-width: 1px 0;
        }
      }
    }
  }
}
</style>
